import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../../Icon';
import CustomLink from '../../CustomLink';
import styles from './IconCard.css';

const cx = classnames.bind(styles);

function renderAction(actionLabel, actionHref) {
    if (!actionLabel) {
        return null;
    }

    if (!actionHref) {
        return <span className={styles.action}>{actionLabel}</span>;
    }

    return (
        <CustomLink
            to={actionHref}
            target={actionHref.startsWith('http') ? '_blank' : 'custom'}
            withDefaultClassName={false}
            className={styles.action}
        >
            {actionLabel}
        </CustomLink>
    );
}

function IconCard({ iconName, title, description, actionLabel, actionHref, isIconOnLeft }) {
    const classes = cx({
        root: true,
        iconOnLeft: isIconOnLeft
    });

    return (
        <li className={classes}>
            <span className={styles.iconBadge}>
                <Icon name={iconName} className={styles.icon} />
            </span>
            <div className={styles.content}>
                <h3 className={styles.title}>{title}</h3>
                <p className={styles.description}>{description}</p>
                {renderAction(actionLabel, actionHref)}
            </div>
        </li>
    );
}

IconCard.propTypes = {
    iconName: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    actionLabel: PropTypes.string,
    actionHref: PropTypes.string,
    isIconOnLeft: PropTypes.bool
};

IconCard.defaultProps = {
    actionLabel: '',
    actionHref: '',
    isIconOnLeft: false
};

export {
    IconCard
};
